//
export default [
  {
    text: 'nombre',
    value: 'structure_name',
  },
  {
    text: 'tipo',
    value: 'hr_contract_type_name',
  },
  {
    text: 'periodo',
    value: 'hr_contract_period_name',
  },
  {
    text: 'modificado',
    value: 'updated_at',
    format: 'datetime',
  },
]